import React, { Suspense, lazy } from "react";
import { Route, Switch } from "react-router-dom";
import Loader from "components/Loader/Loader.js";

import Authenticate from "./views/Users/Authenticate";
import ConfirmEmail from "./views/Users/ConfirmEmail";
import ResetPassword from "./views/Users/ResetPassword/index.js";
import ForgotPassword from "./views/Users/ForgotPassword/index.js";

export const renderRoutes = (routes = []) => (
  <Suspense fallback={<Loader />}>
    <Switch>
      {routes.map((route, key) => {
        const Component = route.component;

        return (
          <Route
            key={key}
            path={`/:lang${route.layout}${route.path}`}
            exact={route.exact}
            render={(props) => <Component {...props} />}
          />
        );
      })}
    </Switch>
  </Suspense>
);

var routes = [
  {
    exact: true,
    path: "/user/auth",
    name: "Authenticate",
    icon: "tim-icons icon-bank",
    component: Authenticate,
    layout: "/public",
  },
  {
    exact: false,
    path: "/user/confirm-email/:token",
    name: "Confrim E-mail",
    icon: "tim-icons icon-chart-pie-36",
    component: ConfirmEmail,
    layout: "/public",
  },
  {
    exact: true,
    path: "/user/change-password",
    name: "Change Password",
    icon: "tim-icons icon-chart-pie-36",
    component: lazy(() => import("./views/Users/ChangePassword")),
    layout: "/issuer",
  },
  {
    exact: true,
    path: "/user/reset-password/:token",
    name: "Reset Password",
    icon: "tim-icons icon-chart-pie-36",
    component: ResetPassword,
    layout: "/public",
  },
  {
    exact: true,
    path: "/user/forgot-password",
    name: "Forgot Password",
    icon: "tim-icons icon-chart-pie-36",
    component: ForgotPassword,
    layout: "/public",
  },
  {
    exact: true,
    path: "/dashboard",
    name: "Landing Page",
    icon: "tim-icons icon-paper",
    component: lazy(() => import("./views/Dashboard")),
    layout: "/issuer",
    show: true,
  },
  {
    exact: true,
    path: "/documents",
    name: "Documents",
    icon: "tim-icons icon-paper",
    component: lazy(() => import("./views/Documents/AllDocuments")),
    layout: "/issuer",
    show: true,
  },
  {
    exact: true,
    path: "/documents/new",
    name: "New Document",
    icon: "tim-icons icon-paper",
    component: lazy(() => import("./views/Documents/New")),
    layout: "/issuer",
    show: true,
  },
  {
    exact: true,
    path: "/documents/details",
    name: "Details Document",
    icon: "tim-icons icon-paper",
    component: lazy(() => import("./views/Documents/Details")),
    layout: "/issuer",
    show: true,
  },
  {
    exact: true,
    path: "/documents/preview",
    name: "Details Document",
    icon: "tim-icons icon-paper",
    component: lazy(() => import("./views/Documents/Preview")),
    layout: "/issuer",
    show: true,
  },
  {
    exact: true,
    path: "/documents/my",
    name: "My Documents",
    icon: "tim-icons icon-paper",
    component: lazy(() => import("./views/Documents/MyDocuments")),
    layout: "/issuer",
    show: true,
  },
  {
    exact: true,
    path: "/settings",
    name: "Settings",
    icon: "tim-icons icon-paper",
    component: lazy(() => import("./views/Settings")),
    layout: "/issuer",
    show: true,
  },
  {
    exact: true,
    path: "/downloads",
    name: "Downloads",
    icon: "tim-icons icon-paper",
    component: lazy(() => import("./views/Downloads")),
    layout: "/issuer",
    show: true,
  },

  {
    exact: true,
    path: "/profile-page",
    name: "Profile Page",
    icon: "tim-icons icon-money-coins",
    component: lazy(() => import("./views/UnderConstruction")),
    layout: "/issuer",
    show: true,
  },
  {
    exact: true,
    path: "/index",
    name: "Index",
    icon: "tim-icons icon-single-02",
    component: lazy(() => import("./views/Index.js")),
    layout: "/public",
  },
  {
    exact: true,
    path: "/icons",
    name: "Nulceo Icons",
    icon: "tim-icons icon-money-coins",
    component: lazy(() => import("./views/NucleoIcons")),
    layout: "/issuer",
    show: true,
  },
];
export default routes;
